import { render } from "./NimbusFlatCard.vue?vue&type=template&id=abd48b90"
import script from "./NimbusFlatCard.vue?vue&type=script&lang=js"
export * from "./NimbusFlatCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__